import React from 'react';
import getIcons from '../../functions/getIcons/getIcons';

const TarapacaIconsSection = props => {
	const createMarkup = data => {
		return {
			__html: data,
		};
	};
	const isBiaggini = props.operator && props.operator.operator_name === 'biaggini';

	return (
		<div className={`themes-theme-two-icons-section new-container`}>
			{getIconsAndTexts(props.operator).map((val, index) => {
				return (
					<div className={`icon-section-item`} key={index}>

						<div className="left">
							<img src={val.icon} alt="" className="image" />
						</div>

						<div className="right">
							<div
								className={`title bold-text`}

								style={{
									color:
										props.operator &&
										props.operator.color_codes &&
										props.operator.color_codes.primary_text_color &&
										props.operator.color_codes.primary_text_color,
								}}
							>
								{val.title}
							</div>
							<div
								className={`desc normal-text`}

								style={{
									color:
										props.operator &&
										props.operator.color_codes &&
										props.operator.color_codes.tertiary_text_color &&
										props.operator.color_codes.tertiary_text_color,
									fontWeight: props.operator.operator_name === 'barriaghisoni' ? 'bold' : '',
								}}
							>
								{val.desc}

							</div>
						</div>
					</div>
				);
			})}
		</div>
	);
};

const getIconsAndTexts = operator => {
	if (operator && operator.operator_name === 'tarapaca') {
		return [
			{
				icon: getIcons('ist', operator),
				title: 'Amplios asientos',
				desc: `Contamos con buses Salón Cama y Buses Suite Premium 180°.`,
			},
			{
				icon: getIcons('second', operator),
				title: 'Convenios con empresas',
				desc: `Accede a precios
        preferenciales al contratar
        servicios corporativos.`,
			},
			{
				icon: getIcons('third', operator),
				title: 'Viajes de turismo',
				desc: `Cotiza y contrata viajes privados con nosotros.`,
			},
		]
	}

	else
		return [
			{
				icon: getIcons('ist', operator),
				title: 'Variedad de asientos',
				desc: 'Viaja cómodamente eligiendo entre asientos Semi cama o Salón cama.',
			},
			{
				icon: getIcons('second', operator),
				title: 'Tecnología a bordo',
				desc: 'Aprovecha las comodidades y cargador USB de nuestros buses durante tu viaje.',
			},
			{
				icon: getIcons('third', operator),
				title: 'Pasaje impreso',
				desc: 'Asegúrate de mostrar tu pasaje impreso al momento de abordar el bus.',
			},
		];
};

export default TarapacaIconsSection;



// WEBPACK FOOTER //
// ./src/features/themes/Tarapaca/common/TarapacaIconsSection.js